import { notification } from "antd";
import axios from "axios";
import jwt_decode from "jwt-decode";

import { message } from "antd";
import { checkServerIdentity } from "tls";

export default class Globais {
  //código desenvolvimento

  // static DOMINIOBACK = "http://127.0.0.1:7000";
  // static DOMINIOFRONT = "http://127.0.0.1:3001";
  // static DOMINIOFRONTPROP = "http://127.0.0.1:3000";

  // static DOMINIOANUNCIO = "http://127.0.0.1:5500";
  // static TITULO = "DESENVOLVIMENTO";

  //fim codigo desenvolvimento
  //código testes
  //
  // static DOMINIOBACK = "https://www.multicotas.com.br:21001";
  // static DOMINIOFRONT = "https://hmldescubra.multicotas.com.br";
  // static DOMINIOANUNCIO = "https://hmlvendas.multicotas.com.br";
   // static DOMINIOFRONTPROP = "https://hml.multicotas.com.br";
  // static TITULO = "HOMOLOGAÇÃO";

  //fim codigo testes

  //código produção

  static DOMINIOBACK = "https://www.multicotas.com.br:21000";
  static DOMINIOFRONT = "https://descubra.multicotas.com.br";
  static DOMINIOANUNCIO = "https://vendas.multicotas.com.br";
  static DOMINIOFRONTPROP = "https://proprietario.multicotas.com.br";
  static TITULO = "";

  static LINK_PAGAMENTO = "https://www.asaas.com/c/eyy51h0myqmhbebz";
  static LINK_PAGAMENTO1 = "https://www.asaas.com/c/eyy51h0myqmhbebz";
  static LINK_PAGAMENTO2 = "https://www.asaas.com/c/ium4w8tk434nxugy";
  static LINK_PAGAMENTO3 = "https://www.asaas.com/c/7ny0le9lno7jwodi";
  static LINK_PAGAMENTO4 = "https://www.asaas.com/c/7p86eelg64vig7l5";
  static LINK_PAGAMENTO5 = "https://www.asaas.com/c/65ojq9f7mt8r6ng7";
  static LINK_PAGAMENTO6 = "https://www.asaas.com/c/rn5sadxkfuikew3e";
  //fim código produção

  static CorTexto = "#fff";
  // static CorTexto = "#465b73";
  static CorVerde = "#003644";
  // static CorVerde = "#5d7366";
  static CorVermelha = "#d63031";
  static CorVerdeConcluido = "#55efc4";
  static CorAmareloUtilizar = "#feca57";
  static CorAzulBackGround = "#003644";
  // static CorAzulBackGround = "#7e9dbf";
  static CorBege = "#E1B12C";
  /*
  
    #casa http://192.168.0.12
    #vovó http://192.168.0.16
*/
}

export function validacaoEmail(email: string) {
  let re = /\S+@\S+\.\S+/;
  return re.test(email);
}

export function validaCPF(cpf: string) {
  var Soma = 0;
  var Resto;

  var strCPF = String(cpf).replace(/[^\d]/g, "");

  if (strCPF.length !== 11) return false;

  if (
    [
      "00000000000",
      "11111111111",
      "22222222222",
      "33333333333",
      "44444444444",
      "55555555555",
      "66666666666",
      "77777777777",
      "88888888888",
      "99999999999",
    ].indexOf(strCPF) !== -1
  )
    return false;

  for (let i = 1; i <= 9; i++)
    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);

  Resto = (Soma * 10) % 11;

  if (Resto == 10 || Resto == 11) Resto = 0;

  if (Resto != parseInt(strCPF.substring(9, 10))) return false;

  Soma = 0;

  for (let i = 1; i <= 10; i++)
    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);

  Resto = (Soma * 10) % 11;

  if (Resto == 10 || Resto == 11) Resto = 0;

  if (Resto != parseInt(strCPF.substring(10, 11))) return false;

  return true;
}

export const validaRg = (rg: string): boolean => {
  // Regex para validar o formato do RG (00.000.000-0)
  const rgRegex = /^\d{2}\.\d{3}\.\d{3}-\d{1}$/;

  return rgRegex.test(rg);
};

export function AlterarFormatoData(props: string): string {
  const dates = props.split("/");

  dates.splice(0, 0, dates[1]);
  dates.splice(2, 1);

  return dates.join("-");
}

// essa função verifica se o periodo adicionado tem menos ou mais de 7 dias e ainda se já existe periodo com mesmos dias de checkin e checkout
// export function validarPeriodoASerAdicionadoAdm(checkIn: string, checkOut: string, periodos: any){
//   let diferenca = CalcularDiferencaDias(
//     AlterarFormatoData(checkIn),
//     AlterarFormatoData(checkOut)
//   );
//   if(diferenca !== 7){
//     return "qtdDiasErrado";
//   }else{
//     console.log(periodos);
//     periodos.map((p: any)=>{

//     });
//   }

// }

//verifica se o período do usuário deve receber uma sugestão ou não
export function VerificarPeriodo(
  checkIn: any,
  checkOut: any,
  status: any,
  alugar: any,
  trocar: any,
  concluido: any,
  utilizar: any,
  fase: any,
  dataSugestao: any
) {
  let situacao = "";
  if (alugar === 1) {
    situacao = "Alugar";
  } else {
    if (trocar === 0 && utilizar === 0 && concluido === 0) {
      situacao = "Não definido";
    }
  }

  if (
    status === "NAO_PERTUBE" ||
    status === "ALTERANDO" ||
    status === "FINALIZADO" ||
    status === "alterado"
  ) {
    return "ok";
  } else {
    if (
      situacao === "Alugar" ||
      situacao === "Alugar ou trocar" ||
      situacao === "Não definido"
    ) {
      let hoje = exibirDataFuncaoDate(new Date());

      let diferenca = CalcularDiferencaDias(
        AlterarFormatoData(checkIn),
        AlterarFormatoData(hoje)
      );

      if (situacao === "Não definido") {
        if (diferenca < 600) {
          return "VerificarNaoDefinido";
        } else {
          return "ok";
        }
      } else {
        if (
          status === "AGUARDANDO_SUGESTAO" ||
          status === "AGUARDANDO_PEDIDO"
        ) {
          if (dataSugestao) {
            let tempoSugerido = CalcularDiferencaDias(
              AlterarFormatoData(hoje),
              formatarDataExibicao(dataSugestao)
            );
            if (tempoSugerido > 30) {
              let diferenca = CalcularDiferencaDias(
                AlterarFormatoData(checkIn),
                AlterarFormatoData(hoje)
              );

              if (diferenca < 0) {
                return "ok";
              } else {
                if (diferenca > 180) {
                  switch (fase) {
                    case "INICIAL":
                      return "VerificarValor";
                    case "FASE0":
                      return "ok";
                    case "FASE1":
                      return "ok";
                    case "FASE2":
                      return "ok";
                    case "FASE3":
                      return "ok";
                    case "FASE4":
                      return "ok";
                    case "FASE5":
                      return "ok";
                  }
                } else {
                  if (diferenca > 150) {
                    switch (fase) {
                      case "INICIAL":
                        return "VerificarValor";
                      case "FASE0":
                        return "VerificarValor";
                      case "FASE1":
                        return "ok";
                      case "FASE2":
                        return "ok";
                      case "FASE3":
                        return "ok";
                      case "FASE4":
                        return "ok";
                      case "FASE5":
                        return "ok";
                    }
                  } else {
                    if (diferenca > 120) {
                      switch (fase) {
                        case "INICIAL":
                          return "VerificarValor";
                        case "FASE0":
                          return "VerificarValor";
                        case "FASE1":
                          return "VerificarValor";
                        case "FASE2":
                          return "ok";
                        case "FASE3":
                          return "ok";
                        case "FASE4":
                          return "ok";
                        case "FASE5":
                          return "ok";
                      }
                    } else {
                      if (diferenca > 90) {
                        switch (fase) {
                          case "INICIAL":
                            return "VerificarValor";
                          case "FASE0":
                            return "VerificarValor";
                          case "FASE1":
                            return "VerificarValor";
                          case "FASE2":
                            return "VerificarValor";
                          case "FASE3":
                            return "ok";
                          case "FASE4":
                            return "ok";
                          case "FASE5":
                            return "ok";
                        }
                      } else {
                        if (diferenca > 60) {
                          switch (fase) {
                            case "INICIAL":
                              return "VerificarValor";
                            case "FASE0":
                              return "VerificarValor";
                            case "FASE1":
                              return "VerificarValor";
                            case "FASE2":
                              return "VerificarValor";
                            case "FASE3":
                              return "VerificarValor";
                            case "FASE4":
                              return "ok";
                            case "FASE5":
                              return "ok";
                          }
                        } else {
                          if (diferenca <= 60) {
                            switch (fase) {
                              case "INICIAL":
                                return "VerificarValor";
                              case "FASE0":
                                return "VerificarValor";
                              case "FASE1":
                                return "VerificarValor";
                              case "FASE2":
                                return "VerificarValor";
                              case "FASE3":
                                return "VerificarValor";
                              case "FASE4":
                                return "VerificarValor";
                              case "FASE5":
                                return "ok";
                            }
                          } else {
                            console.log("Não sei qual a fase");
                          }
                        }
                      }
                    }
                  }
                }
              }
            } else {
              return "ok";
            }
          }
        } else {
          if (diferenca < 0) {
            return "ok";
          } else {
            if (diferenca > 180) {
              switch (fase) {
                case "INICIAL":
                  return "VerificarValor";
                case "FASE0":
                  return "ok";
                case "FASE1":
                  return "ok";
                case "FASE2":
                  return "ok";
                case "FASE3":
                  return "ok";
                case "FASE4":
                  return "ok";
                case "FASE5":
                  return "ok";
              }
            } else {
              if (diferenca > 150) {
                switch (fase) {
                  case "INICIAL":
                    return "VerificarValor";
                  case "FASE0":
                    return "VerificarValor";
                  case "FASE1":
                    return "ok";
                  case "FASE2":
                    return "ok";
                  case "FASE3":
                    return "ok";
                  case "FASE4":
                    return "ok";
                  case "FASE5":
                    return "ok";
                }
              } else {
                if (diferenca > 120) {
                  switch (fase) {
                    case "INICIAL":
                      return "VerificarValor";
                    case "FASE0":
                      return "VerificarValor";
                    case "FASE1":
                      return "VerificarValor";
                    case "FASE2":
                      return "ok";
                    case "FASE3":
                      return "ok";
                    case "FASE4":
                      return "ok";
                    case "FASE5":
                      return "ok";
                  }
                } else {
                  if (diferenca > 90) {
                    switch (fase) {
                      case "INICIAL":
                        return "VerificarValor";
                      case "FASE0":
                        return "VerificarValor";
                      case "FASE1":
                        return "VerificarValor";
                      case "FASE2":
                        return "VerificarValor";
                      case "FASE3":
                        return "ok";
                      case "FASE4":
                        return "ok";
                      case "FASE5":
                        return "ok";
                    }
                  } else {
                    if (diferenca > 60) {
                      switch (fase) {
                        case "INICIAL":
                          return "VerificarValor";
                        case "FASE0":
                          return "VerificarValor";
                        case "FASE1":
                          return "VerificarValor";
                        case "FASE2":
                          return "VerificarValor";
                        case "FASE3":
                          return "VerificarValor";
                        case "FASE4":
                          return "ok";
                        case "FASE5":
                          return "ok";
                      }
                    } else {
                      if (diferenca <= 60) {
                        switch (fase) {
                          case "INICIAL":
                            return "VerificarValor";
                          case "FASE0":
                            return "VerificarValor";
                          case "FASE1":
                            return "VerificarValor";
                          case "FASE2":
                            return "VerificarValor";
                          case "FASE3":
                            return "VerificarValor";
                          case "FASE4":
                            return "VerificarValor";
                          case "FASE5":
                            return "ok";
                        }
                      } else {
                        console.log("Não sei qual a fase");
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      return "ok";
    }
  }
}

//caso a propriedade tenha cronograma, essa função verificará se há períodos no sistema criados sem períodosUsuários dessa propriedade.
export async function acertoPeriodosProprietario(
  usuarioId: number,
  cotaUsuarioId: number
) {
  const hoje = new Date().toLocaleDateString("pt-BR", {
    timeZone: "UTC",
  });

  // criar periodos de uma determinada cota
  const criarPeriodosDoCronograma = async (cotaId: number, Token: any) => {
    if (cotaId !== 0) {
    } else {
      //sendo cotaId zero ele vai ter que buscar cotaId
      const URLCotaUsuario = `${Globais.DOMINIOBACK}/cota-usuario/${cotaUsuarioId}`;
      try {
        const responseCotaUsuario = await axios.get(URLCotaUsuario, {
          headers: { Authorization: Token.AuthStr },
        });
        if (responseCotaUsuario) {
          const URLPeriodos = `${Globais.DOMINIOBACK}/periodo/cota/periodos/${responseCotaUsuario.data.cotaId}/${Token.id}`;
          const URLPeriodosUsuarios = `${Globais.DOMINIOBACK}/periodo-usuario/periodousuario/0/${cotaUsuarioId}`;
          try {
            const responsePeriodos = await axios.get(URLPeriodos, {
              headers: { Authorization: Token.AuthStr },
            });
            const responsePeriodosUsuarios = await axios.get(
              URLPeriodosUsuarios,
              {
                headers: { Authorization: Token.AuthStr },
              }
            );

            if (responsePeriodos && responsePeriodosUsuarios) {
              let periodos: any[] = [];
              let contadorPeriodos = 0;

              responsePeriodos.data.map(async (PE: any) => {
                PE.key = PE.id;
                let contador = 0;
                let teste = 0;

                if (PE.origem === 0) {
                  const diferenca = CalcularDiferencaDias(
                    AlterarFormatoData(formatarData(PE.checkIn)),
                    AlterarFormatoData(hoje)
                  );
                  //periodos que estão vigente
                  if (diferenca >= 0) {
                    responsePeriodosUsuarios.data.map((PEU: any) => {
                      PEU.key = PEU.id;
                      if (PE.id === PEU.PeriodoTable.id) {
                        contador++;
                      }
                    });
                    if (contador === 0) {
                      periodos.push(PE.id);
                    }
                  } else {
                    console.log(`${PE.id} já passou`);
                  }
                } else {
                  console.log(`${PE.id} esse é um período do usuario`);
                }
              });

              if (periodos.length > 0) {
                const URLCriarPeriodosUsuario = `${Globais.DOMINIOBACK}/periodo-usuario/`;
                contadorPeriodos++;

                periodos.map(async (id: any) => {
                  let formData = {
                    periodoId: id,
                    cotasUsuariosId: cotaUsuarioId,
                  };

                  try {
                    const responseCriarPeriodoUsuario = await axios.post(
                      URLCriarPeriodosUsuario,
                      formData,
                      {
                        headers: { Authorization: Token.AuthStr },
                      }
                    );
                    if (responseCriarPeriodoUsuario) {
                    }
                  } catch (e) {
                    console.log(e);
                  }
                });
              }

              if (contadorPeriodos > 0) {
                return 1;
              } else {
                return 0;
              }
            }
          } catch (error) {
            console.log(error);
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const Token = validateToken();

  if (Token) {
    // com o cotaUsuarioId zerado ele vai fazer por usuário
    if (cotaUsuarioId === 0) {
      const URLEmpreendimentos = `${Globais.DOMINIOBACK}/cota-usuario/usuario/${usuarioId}/0`;

      try {
        const responseEmpreendimentos = await axios.get(URLEmpreendimentos, {
          headers: { Authorization: Token.AuthStr },
        });
        if (responseEmpreendimentos) {
          responseEmpreendimentos.data.map((p: any) => {
            if (p.CotaTable.AptoTable.EmpreendimentoTable.cronograma === 1) {
              console.log("Tem cronograma");
            } else {
              console.log("Não tem cronograma");
            }
            return null;
          });
        }
      } catch (err) {
        alert("Há algo de errado. Entre em contato conosco.");
      }
    } else {
      // aqui ele vai criar os períodos de uma determinada cota.
      return criarPeriodosDoCronograma(0, Token);
    }
    //traz todas as propriedades do usuário
  } else {
    console.log("Não encontrei token");
  }
}

// ao passar valor e datas de checkin e checkout a função devolve o valor atualizado. fds determina qual dos períodos fracionados tem o final de semana e deve ser valorizado mais
export async function retornarValorAtualizado(
  valor: string,
  checkIn: string,
  checkOut: string,
  fds: number
) {
  let novaFase;
  let novoValor;
  const percentualfds = 0.5;
  const percentualNaoFds = 0.05;
  let percentualUsado;
  let valorEmNumeros;
  valorEmNumeros = parseFloat(valor.replace(".", "").replace(",", "."));

  let diferenca = CalcularDiferencaDias(
    AlterarFormatoData(checkOut),
    AlterarFormatoData(checkIn)
  );

  if (valor) {
    if (diferenca === 7) {
      novaFase = definirFasePeriodoUsuario({ confirmando: true, checkIn });

      switch (await novaFase) {
        case "FASE5":
          novoValor = +valor * 0.7;
          break;
        case "FASE4":
          novoValor = +valor * 0.75;
          break;
        case "FASE3":
          novoValor = +valor * 0.8;
          break;
        case "FASE2":
          novoValor = +valor * 0.85;
          break;
        case "FASE1":
          novoValor = +valor * 0.9;
          break;
        case "FASE0":
          novoValor = +valor;
          break;
        default:
          novoValor = +valor;
      }

      return exibirMoeda(Math.ceil(novoValor).toString());
    } else {
      if (fds === diferenca) {
        percentualUsado = percentualfds;
      } else {
        percentualUsado = percentualNaoFds;
      }

      return exibirMoeda(
        Math.ceil(
          (valorEmNumeros / 7) * (1 + percentualUsado) * diferenca
        ).toString()
      );
    }
  } else {
    return "";
  }
}

export async function InativarTokenPeriodoUsuario(
  periodoUsuarioId: number,
  token: string
) {
  const Token = validateToken();
  if (Token) {
    const URLToken = `${Globais.DOMINIOBACK}/auth/validarToken/confirmacaoperiodo/inativarToken/${periodoUsuarioId}/${token}`;
    try {
      const responseTokenAlterando = await axios.put(
        URLToken,
        {},
        {
          headers: { Authorization: Token.AuthStr },
        }
      );
      if (responseTokenAlterando) {
        return 1;
      }
    } catch (err) {
      alert("Há algo de errado. Entre em contato conosco.");
      return 2;
    }
  } else {
    console.log("Não econtrei token");
  }

  //       // console.log("atualizado");
  //       if (responseTokenAlterando) {
  //         document.location.href = "/sucessoprocedimento";
  //       } else {
  //         document.location.href = "/algodeuerrado";
  //       }
}

export function verSeTemFracoes(periodoUsuarioId: number, periodos: any) {
  const result = periodos.filter((p: any) => {
    if (p.id === periodoUsuarioId) {
      if (p.children) {
        return 1;
      } else {
        return 0;
      }
    }
  });

  if (result.length === 0) {
    return false;
  } else {
    return true;
  }
}

export function CalcularDiferencaDias(dataFim: any, dataIni: any): number {
  const data2 = dataFim;
  const data1 = dataIni;

  const diffInMs = +new Date(data2) - +new Date(data1);

  // console.log("new Date(data2)");
  // console.log(new Date(data2));
  // console.log("new Date(data1))");
  // console.log(diffInMs);

  const diferenca = diffInMs / (1000 * 60 * 60 * 24);

  return diferenca;
}

type NotificationType = "success" | "info" | "warning" | "error";

export function openNotificationWithIcon(
  type: NotificationType,
  texto: string
) {
  let textoMensagem;

  const [api, contextHolder] = notification.useNotification();

  switch (texto) {
    case "EscolherOpcao":
      textoMensagem = "Favor selecionar uma opção";
      break;
    case "IndicarValor":
      textoMensagem =
        "Como este período não tem um valor registrado ainda, favor escolher a opção 'Gostaria de incluir um novo valor' para alterar o valor sugerido.";
      break;
    case "PeriodoPrincipalDelegado":
      textoMensagem =
        "No período principal você delegou à Multicotas as próximas decisões sobre alterações de preço. Dessa forma os períodos fracionados também deverão estar dessa maneira.";
      break;
    case "SelecionarReservadoUtilizadoEmParte":
      textoMensagem =
        "Favor selecionar no período principal a opção 'Já utilizei ou reservei apenas uma parte do período'.";
      break;
    case "FracioneNaPrimeiraFracao":
      textoMensagem =
        "Caso não deseje fracionar o período, volte a primeira fração e selecione a opção 'Não gostaria de fracionar...'. O sistema não permite ter apenas uma parte do período para aluguel.";
      break;
    case "SelecionarDelegadoNoPrincipal":
      textoMensagem =
        "Caso queira delegar à Multicotas as próximas decisões sobre os preços de um período fracionado, deverá voltar no período principal e selecionar a mesma opção. Ou seja, tanto o principal quanto os fracionados deverão estar na mesma opção.";
      break;
    case "SelecionarNaoPertubeNoPrincipal":
      textoMensagem =
        "Caso não queira mais receber sugestões desse período fracionado, deverá voltar no período principal e selecionar a mesma opção. Ou seja, tanto o principal quanto os fracionados deverão estar na mesma opção.";
      break;
    case "DeveFracionar":
      textoMensagem =
        "Se você reservou ou utilizou apenas parte do período, ele deve, necessariamente, estar fracionado. Caso a fração do período não esteja correta favor entrar em contato conosco.";
      break;
    case "UmPeriodoAoMenosReservadoOuUtilizado":
      textoMensagem =
        "Como você indicou no período principal, que reservou ou utilizou parte do período, você deverá indicar ao menos uma fração como utilizada ou reservada.";
      break;
    case "PreencherValor":
      textoMensagem =
        "Para fins de registro, favor preencher o valor reservado.";
      break;
    case "ErroNoValor":
      textoMensagem =
        "Ops.Parece que tem algo errado com o valor. Certifique-se de que seja somente números.";
      break;
    case "ErrosGerais":
      textoMensagem =
        "Ops. Encotramos um problema ao atualizar as informações. Favor entrar em contato conosco.";

      break;
    case "PrincipalNaoPertube":
      textoMensagem =
        "Caso o período principal esteja marcado para não receber mais sugestões, todas as frações deverão estar na mesma opção.";

      break;

    default:
      textoMensagem = "Algo deu errado!";
      break;
  }
  api[type]({
    message: "Atenção!",
    description: textoMensagem,
    duration: 8,
  });
}

export async function venderCota(
  confirmando: boolean,
  periodoUsuarioId: number,
  cotaUsuarioId: number
) {
  const Token = validateToken();
  console.log(periodoUsuarioId);
  console.log(cotaUsuarioId);

  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuarioId}`;
    let cotaUsuarioIdPreparado;
    try {
      let response;
      if (cotaUsuarioId === 0) {
        response = await axios.get(URL, {
          headers: { Authorization: Token.AuthStr },
        });
        cotaUsuarioIdPreparado = response.data.cotasUsuariosId;
      } else {
        cotaUsuarioIdPreparado = cotaUsuarioId;
      }

      if (response) {
        const URLPeriodosUsuarios = `${Globais.DOMINIOBACK}/periodo-usuario/periodousuario/0/${cotaUsuarioIdPreparado}`;
        const URLCotaUsuario = `${Globais.DOMINIOBACK}/cota-usuario/${cotaUsuarioIdPreparado}`;

        try {
          const responsePeriodosUsuarios = await axios.get(
            URLPeriodosUsuarios,
            {
              headers: { Authorization: Token.AuthStr },
            }
          );
          if (responsePeriodosUsuarios) {
            // let formData9 = {};
            // let formData10 = {};
            // let periodoUsuarioPrincipal = 0;
            let periodoUsuario1Fracao = 0;
            let periodoUsuario2Fracao = 0;
            let formDataPrincipal = {};
            let formData1Fracao = {};
            let formData2Fracao = {};
            let deveEnviarEmail = 1;
            let fracionado = 0;
            let fracaoDivulgada = 0;

            let situacaoAnteriorCancelarPrincipal;
            let situacaoAnteriorCancelar1Fracao: string | undefined;
            let situacaoAnteriorCancelar2Fracao: string | undefined;

            if (confirmando) {
              let result = await responsePeriodosUsuarios.data.map(
                (item: any) => {
                  item.key = item.id;
                  if (item.active === 0 || item.status === "FINALIZADO") {
                    return null;
                  } else {
                    formDataPrincipal = {
                      caso: 9,
                      active: 0,
                      status: "SEM_STATUS",
                      dataSugestao: null,
                      periodoUsuario: item.id,
                    };
                    let resultPrincipal =
                      atualizarPeriodoUsuario(formDataPrincipal);
                  }
                }
              );
              if (result) {
                let formDataCotaUsuario = {
                  active: 0,
                };
                try {
                  const responseCotaUsuario = await axios.put(
                    URLCotaUsuario,
                    formDataCotaUsuario,
                    {
                      headers: { Authorization: Token.AuthStr },
                    }
                  );
                  if (responseCotaUsuario) {
                    let formDataEmail = {
                      tipoEmail: 14,
                      periodoUsuarioId: periodoUsuarioId,
                    };
                    let resultEmail = enviarEmail(formDataEmail);
                    if (await resultEmail) {
                      return 1;
                    } else {
                      return 2;
                    }
                  }
                } catch (error) {
                  return 2;
                }
              }
            } else {
              await responsePeriodosUsuarios.data.map(
                async (item: any, index: any) => {
                  item.key = item.id;
                  if (item.active === 0 || item.status === "FINALIZADO") {
                    return null;
                  } else {
                    if (item.fracionamento === 0) {
                      //tratamento dos principais
                      if (item.divulgado === 0) {
                        //quando o principal não está divulgado
                        fracionado = 0;

                        fracaoDivulgada = 0;
                        periodoUsuario1Fracao = 0;
                        responsePeriodosUsuarios.data.filter(async (p: any) => {
                          //verificando se tem fracionados

                          p.key = p.id;
                          if (p.fracionamento === item.id) {
                            //encontrado um fracionado
                            fracionado = 1;

                            if (p.divulgado === 1) {
                              //fracionado divulgado
                              fracaoDivulgada = 1;
                              deveEnviarEmail = 0;

                              if (periodoUsuario1Fracao === 0) {
                                //tratando primeiro periodo fracionado

                                periodoUsuario1Fracao = p.id;

                                situacaoAnteriorCancelar1Fracao = qualSituacao(
                                  p.alugar,
                                  p.trocar,
                                  p.concluido,
                                  p.utilizar,
                                  1,
                                  ""
                                );
                                return p;
                              } else {
                                //tratando segundo período
                                periodoUsuario2Fracao = p.id;

                                situacaoAnteriorCancelar2Fracao = qualSituacao(
                                  p.alugar,
                                  p.trocar,
                                  p.concluido,
                                  p.utilizar,
                                  1,
                                  ""
                                );

                                return p;
                              }
                            } else {
                              //fracionado não divulgado
                              if (periodoUsuario1Fracao === 0) {
                                periodoUsuario1Fracao = p.id;
                                situacaoAnteriorCancelar1Fracao = qualSituacao(
                                  p.alugar,
                                  p.trocar,
                                  p.concluido,
                                  p.utilizar,
                                  1,
                                  ""
                                );
                                return p;
                              } else {
                                if (periodoUsuario1Fracao === 0) {
                                  periodoUsuario1Fracao = p.id;
                                  situacaoAnteriorCancelar1Fracao =
                                    qualSituacao(
                                      p.alugar,
                                      p.trocar,
                                      p.concluido,
                                      p.utilizar,
                                      1,
                                      ""
                                    );
                                  formData1Fracao = {
                                    caso: 9,
                                    active: 3,
                                    situacaoAnterior:
                                      situacaoAnteriorCancelar1Fracao,
                                    status: "ALTERANDO",
                                    dataSugestao: null,
                                    periodoUsuario: periodoUsuario1Fracao,
                                  };
                                } else {
                                  periodoUsuario2Fracao = p.id;
                                  situacaoAnteriorCancelar2Fracao =
                                    qualSituacao(
                                      p.alugar,
                                      p.trocar,
                                      p.concluido,
                                      p.utilizar,
                                      1,
                                      ""
                                    );
                                  formData2Fracao = {
                                    caso: 9,
                                    active: 3,
                                    situacaoAnterior:
                                      situacaoAnteriorCancelar2Fracao,
                                    status: "ALTERANDO",
                                    dataSugestao: null,
                                    periodoUsuario: periodoUsuario2Fracao,
                                  };
                                }
                              }
                              // if (fracaoDivulgada === 0) {

                              // } else {
                              //   if (periodoUsuario1Fracao === 0) {
                              //     periodoUsuario1Fracao = p.id;
                              //     situacaoAnteriorCancelar1Fracao =
                              //       qualSituacao(
                              //         p.alugar,
                              //         p.trocar,
                              //         p.concluido,
                              //         p.utilizar
                              //       );
                              //     formData1Fracao = {
                              //       caso: 9,
                              //       active: 3,
                              //       situacaoAnterior:
                              //         situacaoAnteriorCancelar1Fracao,
                              //       status: "ALTERANDO",
                              //       dataSugestao: null,
                              //       periodoUsuario: periodoUsuario1Fracao,
                              //     };
                              //   } else {
                              //     periodoUsuario2Fracao = p.id;
                              //     situacaoAnteriorCancelar2Fracao =
                              //       qualSituacao(
                              //         p.alugar,
                              //         p.trocar,
                              //         p.concluido,
                              //         p.utilizar
                              //       );
                              //     formData2Fracao = {
                              //       caso: 9,
                              //       active: 3,
                              //       situacaoAnterior:
                              //         situacaoAnteriorCancelar2Fracao,
                              //       status: "ALTERANDO",
                              //       dataSugestao: null,
                              //       periodoUsuario: periodoUsuario2Fracao,
                              //     };
                              //   }
                              // }
                            }
                          }

                          let result1Fracao =
                            atualizarPeriodoUsuario(formData1Fracao);
                          if (await result1Fracao) {
                            let result2Fracao =
                              atualizarPeriodoUsuario(formData2Fracao);
                            if (await result2Fracao) {
                            } else {
                              console.log(
                                "Não foi possível atualizar períodos."
                              );
                            }
                          } else {
                            openNotificationWithIcon("error", "ErrosGerais");
                          }
                        });
                        if (fracionado === 0) {
                          formDataPrincipal = {
                            caso: 9,
                            active: 0,
                            status: "SEM_STATUS",
                            dataSugestao: null,
                            periodoUsuario: item.id,
                          };
                        } else {
                          if (fracaoDivulgada === 1) {
                            situacaoAnteriorCancelarPrincipal = qualSituacao(
                              item.alugar,
                              item.trocar,
                              item.concluido,
                              item.utilizar,
                              1,
                              ""
                            );
                            formDataPrincipal = {
                              caso: 9,
                              active: 3,
                              situacaoAnterior:
                                situacaoAnteriorCancelarPrincipal,
                              status: "ALTERANDO",
                              dataSugestao: null,
                              periodoUsuario: item.id,
                            };
                            formData1Fracao = {
                              caso: 9,
                              active: 3,
                              situacaoAnterior: situacaoAnteriorCancelar1Fracao,
                              status: "ALTERANDO",
                              dataSugestao: null,
                              periodoUsuario: periodoUsuario1Fracao,
                            };
                            formData2Fracao = {
                              caso: 9,
                              active: 3,
                              situacaoAnterior: situacaoAnteriorCancelar2Fracao,
                              status: "ALTERANDO",
                              dataSugestao: null,
                              periodoUsuario: periodoUsuario2Fracao,
                            };
                          } else {
                            formDataPrincipal = {
                              caso: 9,
                              active: 0,
                              status: "SEM_STATUS",
                              dataSugestao: null,
                              periodoUsuario: item.id,
                            };
                            formData1Fracao = {
                              caso: 9,
                              active: 0,
                              status: "SEM_STATUS",
                              dataSugestao: null,
                              periodoUsuario: periodoUsuario1Fracao,
                            };
                            formData2Fracao = {
                              caso: 9,
                              active: 0,
                              status: "SEM_STATUS",
                              dataSugestao: null,
                              periodoUsuario: periodoUsuario2Fracao,
                            };
                          }
                        }
                        // console.log("formDataPrincipal");
                        // console.log(formDataPrincipal);
                        // console.log("formData1Fracao");
                        // console.log(formData1Fracao);
                        // console.log("formData2Fracao");
                        // console.log(formData2Fracao);
                        // console.log("fracionado");
                        // console.log(fracionado);

                        let resultPrincipal =
                          atualizarPeriodoUsuario(formDataPrincipal);
                        if (fracionado === 1 && (await resultPrincipal)) {
                          let result1Fracao =
                            atualizarPeriodoUsuario(formData1Fracao);
                          if (await result1Fracao) {
                            let result2Fracao =
                              atualizarPeriodoUsuario(formData2Fracao);
                            if (await result2Fracao) {
                            } else {
                              console.log(
                                "Erro ao atualizar periodo 2 Fracao: " + item.id
                              );
                            }
                          } else {
                            console.log(
                              "Erro ao atualizar periodo 1 Fracao: " + item.id
                            );
                          }
                        } else {
                          console.log(
                            "Erro ao atualizar periodo principal: " + item.id
                          );
                        }
                      } else {
                        //quando o principal está divulgado

                        fracionado = 0;
                        deveEnviarEmail = 0;
                        periodoUsuario1Fracao = 0;
                        responsePeriodosUsuarios.data.filter(async (p: any) => {
                          p.key = p.id;
                          if (p.fracionamento === item.id) {
                            fracionado = 1;

                            if (periodoUsuario1Fracao === 0) {
                              periodoUsuario1Fracao = 1;
                              situacaoAnteriorCancelar1Fracao = qualSituacao(
                                p.alugar,
                                p.trocar,
                                p.concluido,
                                p.utilizar,
                                1,
                                ""
                              );
                              formData1Fracao = {
                                caso: 9,
                                active: 3,
                                situacaoAnterior:
                                  situacaoAnteriorCancelar1Fracao,
                                status: "ALTERANDO",
                                dataSugestao: null,
                                periodoUsuario: p.id,
                              };
                              return p;
                            } else {
                              periodoUsuario2Fracao = p.id;
                              situacaoAnteriorCancelar2Fracao = qualSituacao(
                                p.alugar,
                                p.trocar,
                                p.concluido,
                                p.utilizar,
                                1,
                                ""
                              );
                              formData2Fracao = {
                                caso: 9,
                                active: 3,
                                situacaoAnterior:
                                  situacaoAnteriorCancelar2Fracao,
                                status: "ALTERANDO",
                                dataSugestao: null,
                                periodoUsuario: p.id,
                              };
                              return p;
                            }
                          }
                        });
                        situacaoAnteriorCancelarPrincipal = qualSituacao(
                          item.alugar,
                          item.trocar,
                          item.concluido,
                          item.utilizar,
                          1,
                          ""
                        );
                        formDataPrincipal = {
                          caso: 9,
                          active: 3,
                          situacaoAnterior: situacaoAnteriorCancelarPrincipal,
                          status: "ALTERANDO",
                          dataSugestao: null,
                          periodoUsuario: item.id,
                        };
                        // console.log("pai divulgado");
                        // console.log("formDataPrincipal");
                        // console.log(formDataPrincipal);
                        // console.log("formData1Fracao");
                        // console.log(formData1Fracao);
                        // console.log("formData2Fracao");
                        // console.log(formData2Fracao);
                        // console.log("fracionado");
                        // console.log(fracionado);

                        let resultPrincipal =
                          atualizarPeriodoUsuario(formDataPrincipal);
                        if (fracionado === 1 && (await resultPrincipal)) {
                          let result1Fracao =
                            atualizarPeriodoUsuario(formData1Fracao);
                          if (await result1Fracao) {
                            let result2Fracao =
                              atualizarPeriodoUsuario(formData2Fracao);
                            if (await result2Fracao) {
                            } else {
                              console.log(
                                "Erro ao atualizar periodo 2 Fracao: " + item.id
                              );
                            }
                          } else {
                            console.log(
                              "Erro ao atualizar periodo 1 Fracao: " + item.id
                            );
                          }
                        } else {
                          console.log(
                            "Erro ao atualizar periodo principal: " + item.id
                          );
                        }
                      }
                    } else {
                      //pulando tratamento dos fracionados agora
                      return null;
                    }
                  }
                }
              );

              if (deveEnviarEmail === 0) {
                return 1;
              } else {
                let formDataCotaUsuario = {
                  active: 0,
                };
                try {
                  const responseCotaUsuarioUpdate = await axios.put(
                    URLCotaUsuario,
                    formDataCotaUsuario,
                    {
                      headers: { Authorization: Token.AuthStr },
                    }
                  );
                  if (responseCotaUsuarioUpdate) {
                    let formDataEmail = {
                      tipoEmail: 14,

                      periodoUsuarioId: periodoUsuarioId,
                    };
                    let resultEmail = enviarEmail(formDataEmail);
                    if (await resultEmail) {
                      return 1;
                    } else {
                      return 2;
                    }
                  }
                } catch (error) {
                  return 2;
                }
              }
            }
          } else {
            openNotificationWithIcon("error", "ErrosGerais");
          }
        } catch (error) {
          openNotificationWithIcon("error", "ErrosGerais");
        }
      } else {
        openNotificationWithIcon("error", "ErrosGerais");
      }
    } catch (error) {
      openNotificationWithIcon("error", "ErrosGerais");
    }
  } else {
    document.location.href = "/login";
  }
}

export async function deletarSomentePeriodosUsuarios(periodoUsuarioId: any) {
  const Token = validateToken();
  let periodoUsuario1Fracao = 0;
  let periodoUsuario2Fracao = 0;
  let formDataPrincipal = {};
  let formData1Fracao = {};
  let formData2Fracao = {};
  let temFracao = false;

  if (Token) {
    const URLPEUFrac = `${Globais.DOMINIOBACK}/periodo-usuario/fracionados/${periodoUsuarioId}`;
    const URLDeletarPrincipal = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuarioId}`;

    try {
      const responsePEUFrac = await axios.get(URLPEUFrac, {
        headers: { Authorization: Token.AuthStr },
      });
      if (responsePEUFrac.data.length > 0) {
        temFracao = true;
        responsePEUFrac.data.filter(async (p: any) => {
          p.key = p.id;
          if (periodoUsuario1Fracao === 0) {
            periodoUsuario1Fracao = p.id;
          } else {
            periodoUsuario2Fracao = p.id;
          }
        });
        // formData1Fracao = {
        //   caso: 2,
        //   periodoUsuario: +periodoUsuario1Fracao,
        //   active: 0,
        // };
        // formData2Fracao = {
        //   caso: 2,
        //   periodoUsuario: +periodoUsuario2Fracao,
        //   active: 0,
        // };
      }
      // formDataPrincipal = {
      //   caso: 2,
      //   periodoUsuario: +periodoUsuarioId,
      //   active: 0,
      // };

      if (temFracao) {
        const URLDeletar1Fracao = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuario1Fracao}`;
        const URLDeletar2Fracao = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuario2Fracao}`;
        try {
          const responseDelete1 = await axios.delete(URLDeletar1Fracao, {
            headers: { Authorization: Token.AuthStr },
          });
          if (responseDelete1) {
            const responseDelete2 = await axios.delete(URLDeletar2Fracao, {
              headers: { Authorization: Token.AuthStr },
            });
            if (responseDelete2) {
              const responseDeletePrincipal = await axios.delete(
                URLDeletarPrincipal,
                {
                  headers: { Authorization: Token.AuthStr },
                }
              );
              if (responseDeletePrincipal) {
                return 1;
              }
            }
          }
        } catch (e) {
          console.log(e);
        }
      } else {
        try {
          const responseDeletePrincipal = await axios.delete(
            URLDeletarPrincipal,
            {
              headers: { Authorization: Token.AuthStr },
            }
          );
          if (responseDeletePrincipal) {
            return 1;
          }
        } catch (e) {
          console.log(e);
        }
      }
    } catch (err) {
      return 3;
    }
  } else {
    return 2;
  }
}

export async function deletarSomenteFracionados(periodoUsuarioId: any) {
  const Token = validateToken();
  let periodoUsuario1Fracao = 0;
  let periodoUsuario2Fracao = 0;
  let formDataPrincipal = {};
  let formData1Fracao = {};
  let formData2Fracao = {};
  let temFracao = false;

  if (Token) {
    const URLPEUFrac = `${Globais.DOMINIOBACK}/periodo-usuario/fracionados/${periodoUsuarioId}`;

    try {
      const responsePEUFrac = await axios.get(URLPEUFrac, {
        headers: { Authorization: Token.AuthStr },
      });
      if (responsePEUFrac.data.length > 0) {
        temFracao = true;
        responsePEUFrac.data.filter(async (p: any) => {
          p.key = p.id;
          if (periodoUsuario1Fracao === 0) {
            periodoUsuario1Fracao = p.id;
          } else {
            periodoUsuario2Fracao = p.id;
          }
        });
      }

      if (temFracao) {
        const URLDeletar1Fracao = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuario1Fracao}`;
        const URLDeletar2Fracao = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuario2Fracao}`;
        try {
          const responseDelete1 = await axios.delete(URLDeletar1Fracao, {
            headers: { Authorization: Token.AuthStr },
          });
          if (responseDelete1) {
            const responseDelete2 = await axios.delete(URLDeletar2Fracao, {
              headers: { Authorization: Token.AuthStr },
            });
          }
        } catch (e) {
          console.log(e);
        }
      }
    } catch (err) {
      return 3;
    }
  } else {
    logout();
  }
}

export async function naoFracione(
  periodoUsuarioId: number,
  divulgado1: number,
  divulgado2: number,
  divulgado3: number,
  alterando: boolean
) {
  let formData = {};
  const Token = validateToken();
  let periodoUsuario1Fracao = 0;
  let periodoUsuario2Fracao = 0;
  let situacaoAnterior;
  if (Token) {
    const URLPEUFrac = `${Globais.DOMINIOBACK}/periodo-usuario/fracionados/${periodoUsuarioId}`;
    try {
      const responsePEUFrac = await axios.get(URLPEUFrac, {
        headers: { Authorization: Token.AuthStr },
      });
      if (responsePEUFrac.data.length > 0) {
        responsePEUFrac.data.filter(async (p: any) => {
          p.key = p.id;
          if (periodoUsuario1Fracao === 0) {
            situacaoAnterior = qualSituacao(
              p.alugar,
              p.trocar,
              p.concluido,
              p.utilizar,
              1,
              ""
            );
            periodoUsuario1Fracao = p.id;
            if (
              divulgado1 === 1 ||
              divulgado2 === 1 ||
              divulgado3 === 1 ||
              alterando
            ) {
              formData = {
                status: "ALTERANDO",
                statusAnterior: "NAO_FRACIONE",
                situacaoAnterior: situacaoAnterior,
                caso: 2,
                periodoUsuario: periodoUsuario1Fracao,
              };
            } else {
              deletarPeriodoUsuario(periodoUsuario1Fracao, true);
            }
          } else {
            periodoUsuario2Fracao = p.id;
            situacaoAnterior = qualSituacao(
              p.alugar,
              p.trocar,
              p.concluido,
              p.utilizar,
              1,
              ""
            );

            if (
              divulgado1 === 1 ||
              divulgado2 === 1 ||
              divulgado3 === 1 ||
              alterando
            ) {
              formData = {
                status: "ALTERANDO",
                statusAnterior: "NAO_FRACIONE",
                situacaoAnterior: situacaoAnterior,
                caso: 2,
                periodoUsuario: periodoUsuario2Fracao,
              };
            } else {
              deletarPeriodoUsuario(periodoUsuario2Fracao, true);
            }
          }
          // console.log(formData);
          atualizarPeriodoUsuario(formData);
        });

        return 1;
      } else {
        return 4;
      }
    } catch (err) {
      return 3;
    }
  } else {
    return 2;
  }
}
export function formatarMoeda(valor: string) {
  let count = 0;

  let pos = valor.indexOf(",");

  while (pos !== -1) {
    count++;

    pos = valor.indexOf(",", pos + 1 /* o mesmo que 3 + 1 */);
  }

  const iterator = valor[Symbol.iterator]();
  let theChar = iterator.next();
  let NotZero = 0;

  while (!theChar.done && theChar.value != "0") {
    NotZero++;
    theChar = iterator.next();
  }

  if (count > 1) {
    alert("Tem algo errado com o valor do aluguel. Favor verificar.");
    return "0";
  } else {
    if (NotZero === 0) {
      return 0;
    } else {
      if (valor == "" || valor == "R$ 0,00" || valor == "NaN") {
        return 0;
      } else {
        let valorNovo;
        let valorPreparado = valor.replaceAll(".", "");
        let valorPreparado2 = valorPreparado.replaceAll(",", ".");

        let valorPreparado3 = new Intl.NumberFormat("pt-BR", {
          minimumFractionDigits: 2,
        })
          .format(+valorPreparado2)
          .toString();

        let valorPreparado4 = valorPreparado3.replace(".", "");
        valorNovo = valorPreparado4.replaceAll(",", ".");

        return valorNovo;
      }
    }
  }
}

export function exibirMoeda(valor: string) {
  let valorNovo;

  if (valor == undefined) {
    return "";
  } else {
    let valorPreparado = valor.replace(",", ".");
    valorNovo = new Intl.NumberFormat("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
      .format(+valorPreparado)
      .toString();
  }

  return valorNovo;
}

export function formatarDataExibicao(props: string): string {
  const dates1 = props?.split("T");

  if (dates1 !== undefined) {
    return dates1[0];
  }
  return "erro";
}

//ao ser passado uma data no formato DD/MM/YYYY essa função retorna o dia da semana. onde 0 é domingo e 6 é sábado
export function retornaDiaDaSemana(props: string): number {
  const data = props;
  let variavel = data.split("/").reverse();
  console.log(data);
  let variavel1: any;
  variavel1 = variavel[1];
  let variavel2 = variavel1 - 1;

  let variavel3 = new Date(+variavel[0], variavel2, +variavel[2]);

  return variavel3.getDay();
}

export function exibirDataFuncaoDate(props: any) {
  let data = props;
  let dataFormatada =
    data.getDate() + "/" + (data.getMonth() + 1) + "/" + data.getFullYear();
  return dataFormatada;
}
export function formatarData(props: string): string {
  const dates1 = props?.split("T");

  if (dates1 !== undefined) {
    const dates2 = dates1[0]?.split("-");
    return `${dates2[2]}/${dates2[1]}/${dates2[0]}`;
  }
  return "erro";
}

export function validateCelular(props: string): any {
  const celular = props.split("");

  console.log("celular");
  console.log(celular);

  if (celular.length === 0) {
    return "Favor verificar o número celular!";
  } else {
    if (celular.length < 10) {
      return "Favor verificar o número celular!";
    } else {
      return false;
    }
  }
}
export function validateCPF(props: string): any {
  const CPF = props.split("");

  if (CPF.length !== 14) {
    return "Favor verificar o número do CPF!";
  } else {
    return false;
  }
}
export function validateDataPeriodo(props: string): any {
  const dates1 = props.split("-");

  const anoAtual = new Date().getFullYear();
  const mesAtual = new Date().getMonth() + 1;
  const diaAtual = new Date().getDate();
  const anoLimite = anoAtual + 20;

  if (+dates1[0] > anoLimite) {
    return "O multicotas não permite a inclusão de períodos maiores que 20 anos.";
  } else if (+dates1[0] < anoAtual) {
    return "Essa data já passou!";
  } else if (+dates1[0] == anoAtual && +dates1[1] < mesAtual) {
    return "Essa data já passou!";
  } else if (
    +dates1[0] == anoAtual &&
    +dates1[1] == mesAtual &&
    +dates1[2] < diaAtual
  ) {
    return "Essa data já passou!";
  } else {
    return "ok";
  }
}

export function validateData(props: string): any {
  const dates1 = props.split("");
  const dates2 = props.split("/");
  const anoAtual = new Date().getFullYear();
  const mesAtual = new Date().getMonth() + 1;
  const diaAtual = new Date().getDate();
  const anoLimite = anoAtual + 21;
  const qtdBarra = props.match(/\//g);

  if (qtdBarra === null) {
    return "O formato da data deve ser DD/MM/YYYY";
  } else if (qtdBarra.length != 2) {
    return "O formato da data deve ser DD/MM/YYYY";
  } else if (dates1.indexOf(" ") > -1) {
    return "Há espaços na data";
  } else if (dates2[0] > "31" || dates2[0].length > 2 || dates2[0].length < 2) {
    return "Tem algo errado no dia";
  } else if (dates2[1] > "12" || dates2[1].length > 2 || dates2[1].length < 2) {
    return "Tem algo errado no mês";
  } else if (dates2[2].length > 4 || dates2[2].length < 4) {
    return "Tem algo errado no ano";
  } else if (dates2[2] > anoLimite.toString()) {
    return "O multicotas limita períodos maiores de 20 anos.";
  } else if (dates2[2] < anoAtual.toString()) {
    return "Essa data já passou!";
  } else if (
    dates2[2] == anoAtual.toString() &&
    dates2[1] < mesAtual.toString()
  ) {
    return "Essa data já passou!";
  } else if (
    dates2[2] == anoAtual.toString() &&
    dates2[1] == mesAtual.toString() &&
    dates2[0] < diaAtual.toString()
  ) {
    return "Essa data já passou!";
  } else {
    return "ok";
  }
}

export function verificarSituacaoFracionados(
  tipo: string,
  periodoUsuarioId: number,
  props: any
) {
  let situacoes: any[];

  if (tipo === "ViewDisponibilizacaoPeriodos") {
    let contadorProprio = 0;
    let contadorMC = 0;
    situacoes = props.map((p: any) => {
      if (p.fracionamento === periodoUsuarioId) {
        switch (p.situacao) {
          case "Será utilizado":
          case "Trocar":
          case "Reservado pelo próprio":
            contadorProprio++;
            break;

          case "Reservado por MC":
            contadorMC++;
            break;
        }
      } else {
        return null;
      }
    });
    if (contadorMC !== 0) {
      return 1;
    } else {
      if (contadorProprio !== 0) {
        return 2;
      } else {
        return 0;
      }
    }
  } else {
    console.log("Não");
  }
}

//confere se a segunda data passada na props é maior que a primeira se sim retorna true. formato datas dd/mm/yyyy
export function validateDataCheckOutMaior(
  checkInProps: string,
  checkOutProps: string
): boolean {
  if (checkInProps && checkOutProps) {
    const checkInValidate = checkInProps.split("/");
    const checkOutValidate = checkOutProps.split("/");

    let checkInValidateNovo = checkInValidate.filter((p: any) => {
      if (p == "undefined") {
        return null;
      } else {
        return p;
      }
    });
    let checkOutValidateNovo = checkOutValidate.filter((p: any) => {
      if (p == "undefined") {
        return null;
      } else {
        return p;
      }
    });

    if (+checkInValidateNovo[2] > +checkOutValidateNovo[2]) {
      return false;
    } else if (
      +checkInValidateNovo[1] > +checkOutValidateNovo[1] &&
      +checkInValidateNovo[2] === +checkOutValidateNovo[2]
    ) {
      return false;
    } else if (
      +checkInValidateNovo[0] >= +checkOutValidateNovo[0] &&
      +checkInValidateNovo[1] === +checkOutValidateNovo[1]
    ) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
}

export function validatePeriodoFracionado(
  checkInPeriodoProps: any,
  checkOutPeriodoProps: any,
  checkInPrimeiroPeriodoProps: any,
  checkOutPrimeiroPeriodoProps: any,
  checkInSegundoPeriodoProps: any,
  checkOutSegundoPeriodoProps: any
): any {
  let date1 = "";
  let date2 = "";
  let date3 = "";
  let date4 = "";

  if (checkInPrimeiroPeriodoProps !== "") {
    date1 = new Date(
      formatarDataDayJs(checkInPrimeiroPeriodoProps)
    ).toLocaleDateString("pt-BR", { timeZone: "UTC" });
  }
  if (checkOutPrimeiroPeriodoProps !== "") {
    date2 = new Date(
      formatarDataDayJs(checkOutPrimeiroPeriodoProps)
    ).toLocaleDateString("pt-BR", { timeZone: "UTC" });
  }
  if (checkInSegundoPeriodoProps !== "") {
    date3 = new Date(
      formatarDataDayJs(checkInSegundoPeriodoProps)
    ).toLocaleDateString("pt-BR", { timeZone: "UTC" });
  }
  if (checkOutSegundoPeriodoProps !== "") {
    date4 = new Date(
      formatarDataDayJs(checkOutSegundoPeriodoProps)
    ).toLocaleDateString("pt-BR", { timeZone: "UTC" });
  }
  const hoje = new Date().toLocaleDateString("pt-BR", {
    timeZone: "UTC",
  });
  const dataCheckInPeriodo = new Date(
    formatarDataDayJs(checkInPeriodoProps)
  ).toLocaleDateString("pt-BR", { timeZone: "UTC" });
  const dataCheckOutPeriodo = new Date(
    formatarDataDayJs(checkOutPeriodoProps)
  ).toLocaleDateString("pt-BR", { timeZone: "UTC" });

  if (date1 === "") {
    return "Favor preencher o primeiro período.";
  } else {
    if (validateSegundaDataEMaior(date1, hoje)) {
      return "A data de check-in não pode ser anterior a data de hoje.";
    } else {
      if (validateSegundaDataEMaior(date1, dataCheckInPeriodo)) {
        return " A data de check-in não pode ser anterior a data de check-in do período fracionado.";
      } else {
        if (validateSegundaDataEMaior(dataCheckOutPeriodo, date2)) {
          return "A data de check-out não pode ser posterior a data de check-out do período fracionado.";
        } else {
          if (date1 === date2) {
            return " A data de check-in não pode ser igual a data de check-out.";
          } else {
            if (date3 === "") {
              return "ok";
            }
          }
        }
      }
    }
  }

  if (date3 !== "") {
    if (validateSegundaDataEMaior(date3, hoje)) {
      return "A data de check-in não pode ser anterior a data de hoje.";
    } else {
      if (validateSegundaDataEMaior(date3, dataCheckInPeriodo)) {
        return " A data de check-in não pode ser anterior a data de check-in do período fracionado.";
      } else {
        if (validateSegundaDataEMaior(dataCheckOutPeriodo, date4)) {
          return "A data de check-out não pode ser posterior a data de check-out do período fracionado.";
        } else {
          if (date3 === date4) {
            return " A data de check-in não pode ser igual a data de check-out.";
          } else {
            if (date2 !== "" && validateSegundaDataEMaior(date3, date2)) {
              return "Data de check-in do segundo período não pode ser anterior a data de check-out do primeiro período.";
            } else {
              return "ok";
            }
          }
        }
      }
    }
  }
}

export function validateSegundaDataEMaior(
  checkInProps: string,
  checkOutProps: string
): boolean {
  const checkInValidate = checkInProps.split("/");
  const checkOutValidate = checkOutProps.split("/");

  if (+checkOutValidate[2] > +checkInValidate[2]) {
    return true;
  } else if (
    +checkOutValidate[1] > +checkInValidate[1] &&
    +checkInValidate[2] === +checkOutValidate[2]
  ) {
    return true;
  } else if (
    +checkOutValidate[0] > +checkInValidate[0] &&
    +checkInValidate[1] === +checkOutValidate[1] &&
    +checkInValidate[2] === +checkOutValidate[2]
  ) {
    return true;
  } else {
    return false;
  }
}
export function adicionarDiasData(date: string, dias: number): string {
  const dateNovo = new Date(formatarDataDayJs(date));
  dateNovo.setDate(dateNovo.getDate() + dias);

  return dateNovo.toLocaleDateString("pt-BR", {
    timeZone: "UTC",
  });

  // if (+checkOutValidate[2] > +checkInValidate[2]) {
  //   return true;
  // } else if (
  //   +checkOutValidate[1] > +checkInValidate[1] &&
  //   +checkInValidate[2] === +checkOutValidate[2]
  // ) {
  //   return true;
  // } else if (
  //   +checkOutValidate[0] > +checkInValidate[0] &&
  //   +checkInValidate[1] === +checkOutValidate[1] &&
  //   +checkInValidate[2] === +checkOutValidate[2]
  // ) {
  //   return true;
  // } else {
  //   return false;
  // }
}

export function formatarDataDayJs(date: any) {
  const newDate = date.split();

  const day = `${newDate[0][0]}${newDate[0][1]}`;
  const month = `${newDate[0][3]}${newDate[0][4]}`;
  const year = `${newDate[0][6]}${newDate[0][7]}${newDate[0][8]}${newDate[0][9]}`;

  // let day = +new Date(date).getDate();
  // let month = new Date(date).getMonth() + 1;
  // let year = +new Date(date).getFullYear();

  return `${year}-${month}-${day}`;
}

export function logout(): void {
  localStorage.clear();
  document.location.href = "/login";
}

const Token = {
  AuthStr: "",
  id: "",
  nda: 0,
};

export function validateToken() {
  const token = localStorage.getItem("accessToken");

  if (token) {
    const AuthStr = `Bearer ${token}`;
    const sub = Object(jwt_decode(token)).sub;
    const now = new Date().getTime();
    const exp = Object(jwt_decode(token)).exp * 1000;
    const nda = +Object(jwt_decode(token)).nda;
    Token.id = sub;
    Token.AuthStr = AuthStr;
    Token.nda = nda;
    if (now > exp) {
      logout();
    } else {
      return Token;
    }
  } else {
    console.log("sem token");
  }
}
export function validateTokenEmail() {
  const token = localStorage.getItem("accessToken");

  if (token) {
    const AuthStr = `Bearer ${token}`;
    const sub = Object(jwt_decode(token)).sub;
    const now = new Date().getTime();
    const exp = Object(jwt_decode(token)).exp * 1000;
    const nda = +Object(jwt_decode(token)).nda;
    Token.id = sub;
    Token.AuthStr = AuthStr;
    Token.nda = nda;
    if (now > exp) {
      console.log("Vai para login");
    } else {
      return Token;
    }
  } else {
    console.log("token não encontrado");
  }
}

//enviar email

export async function enviarEmail(props: any) {
  //tipos:
  //1: usado para enviar email de forma genérica a um usuário
  //2: autenticação de periodo
  let valorPrincipal = props.valorPrincipal;
  let valor1Fracao = props.valor1Fracao;
  let valor2Fracao = props.valor2Fracao;

  const Token = validateToken();

  switch (props.tipoEmail) {
    case 1:

    case 2:
      const userId = props.userId;
      const tipoEmail = +props.tipoEmail;
      const subjectEmail = props.subjectEmail;
      const bodyEmailAntes = props.bodyEmail;
      const bodyEmail = bodyEmailAntes?.replaceAll("\n", "<br />");
      const empreend = props.empreend;
      const empreendEstado = props.empreendEstado;
      const empreendCidade = props.empreendCidade;
      // Apartamento
      const nomeAp = props.nomeAp;
      const capacidadeAp = props.capacidadeAp;
      const quartosAp = props.quartosAp;
      const banheirosAp = props.banheirosAp;
      const varandaAp = props.varandaAp;
      const terreoAp = props.terreoAp;
      const estacionamentoAp = props.estacionamentoAp;
      // Mais Info Apto
      const numeroAp = props.numeroAp;
      const andarAp = props.andarAp;
      const blocoAp = props.blocoAp;
      const vistaAp = props.vistaAp;
      // Representante
      const nomeRepresentante = props.nomeRepresentante;
      // Cota
      const numeroCota = props.numeroCota;
      const qtdSemanas = props.qtdSemanas;
      const diaDaSemanaInicio = props.diaDaSemanaInicio;
      const prioridade = props.prioridade;
      // Mais Info Anuncio Propriedade
      const situacaoPropriedade = props.situacaoPropriedade;
      const valorVenda = props.valorVenda;
      const valorCondominio = props.valorCondominio;
      const saldoDevedor = props.saldoDevedor;

      if (Token) {
        const URL = `${Globais.DOMINIOBACK}/usuario/email`;
        let formData = {
          userId: userId,
          tipoEmail: tipoEmail,
          bodyEmail: bodyEmail,
          subjectEmail: subjectEmail,
          empreend: empreend,
          empreendEstado: empreendEstado,
          empreendCidade: empreendCidade,
          // Apartamento
          nomeAp: nomeAp,
          capacidadeAp: capacidadeAp,
          quartosAp: quartosAp,
          banheirosAp: banheirosAp,
          varandaAp: varandaAp,
          terreoAp: terreoAp,
          estacionamentoAp: estacionamentoAp,
          // Mais Info Apto
          numeroAp: numeroAp,
          andarAp: andarAp,
          blocoAp: blocoAp,
          vistaAp: vistaAp,
          // Representante
          nomeRepresentante: nomeRepresentante,
          // Cota
          numeroCota: numeroCota,
          qtdSemanas: qtdSemanas,
          diaDaSemanaInicio: diaDaSemanaInicio,
          prioridade: prioridade,
          // Mais Info Anuncio Propriedade
          situacaoPropriedade: situacaoPropriedade,
          valorVenda: valorVenda,
          valorCondominio: valorCondominio,
          saldoDevedor: saldoDevedor,
        };

        try {
          const response = await axios.post(URL, formData, {
            headers: { Authorization: Token.AuthStr },
          });

          return response.data;
        } catch (error) {
          return false;
        }
      } else {
        document.location.href = "/";
      }

      break;
    //case 3 - atualizar valor aluguel a pedido
    //case 5 - atualizar valor aluguel a pedido com período fracionado
    case 0:
    case 3:
    case 4:
    case 5:
    case 6:
    case 7:
    case 8:
    case 9:
    case 10:
    case 11:
    case 12:
    case 13:
      // Envio de e-mail para periodo reservado pelo proprio
      if (Token) {
        const URL = `${Globais.DOMINIOBACK}/periodo-usuario/email`;

        try {
          const response = await axios.post(URL, props, {
            headers: { Authorization: Token.AuthStr },
          });

          if (response) {
            if (response?.data?.response?.status === 206) {
              return "Falha ao enviar WhatsApp. Mas e-mail enviado.";
            } else {
              if (response?.data?.response?.status === 502) {
                return response?.data?.response?.error;
              } else {
                return "Mensagens enviadas com sucesso.";
              }
            }
            // return "Mensagens enviadas com sucesso";
          }
        } catch (error) {
          return error.response.data.detalhes;
        }
      } else {
        document.location.href = "/";
      }
      break;
    case 14:
    case 15:
    case 16:
      if (Token) {
        const URL = `${Globais.DOMINIOBACK}/periodo-usuario/email`;

        try {
          const response = await axios.post(URL, props, {
            headers: { Authorization: Token.AuthStr },
          });

          if (response.data) {
            return true;
          } else {
            return false;
          }
        } catch (error) {
          console.log(error);
          return false;
        }
      } else {
        document.location.href = "/";
      }
      break;
    case 17:
      if (Token) {
        const URL = `${Globais.DOMINIOBACK}/periodo-usuario/email`;

        try {
          const response = await axios.post(URL, props, {
            headers: { Authorization: Token.AuthStr },
          });
          console.log(props);
          console.log(response.data);
          if (response.data.response.status) {
            if (response.data.response.status === 206) {
              return "Falha ao enviar WhatsApp. Mas e-mail enviado.";
            } else {
              if (response.data.response.status === 502) {
                return "Falha. Não foi enviado E-mail e Whatsapp.";
              } else {
                return "Mensagens enviadas com sucesso.";
              }
            }
            // return "Mensagens enviadas com sucesso";
          } else {
            if (response) {
              return true;
            }
          }
        } catch (error) {
          console.log(error);
          return false;
        }
      } else {
        document.location.href = "/";
      }
      break;
    case 18:
    case 19:
      if (Token) {
        const URL = `${Globais.DOMINIOBACK}/periodo-usuario/email`;

        try {
          const response = await axios.post(URL, props, {
            headers: { Authorization: Token.AuthStr },
          });

          if (response) {
            return true;
          } else {
            return false;
          }
        } catch (error) {
          console.log(error);
          return false;
        }
      } else {
        document.location.href = "/";
      }
      break;
    case 20:
      if (Token) {
        const URL = `${Globais.DOMINIOBACK}/usuario/email`;

        try {
          const response = await axios.post(URL, props, {
            headers: { Authorization: Token.AuthStr },
          });

          if (response) {
            return true;
          }
        } catch (error) {
          return false;
        }
      }
      break;
    case 21:
      if (Token) {
        const URL = `${Globais.DOMINIOBACK}/usuario/email`;

        try {
          const response = await axios.post(URL, props, {
            headers: { Authorization: Token.AuthStr },
          });

          if (response) {
            if (response.data.response.status === 502) {
              return 502;
            }

            return 200;
          }
        } catch (error) {
          console.log(error);
          return false;
        }
      }
      break;
  }
}

export function setCookie(nomeProps: string, valorProps: string) {
  localStorage.setItem(nomeProps, valorProps);
}

export function getCookie(nomeProps: string): string {
  const cookie = localStorage.getItem(nomeProps);
  if (cookie) {
    return cookie;
  } else {
    return "0";
  }
}

export async function qualStatusAtualPeriodoUsuario(periodoUsuarioId: number) {
  const Token = validateToken();
  const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuarioId}`;
  if (Token) {
    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response) {
        return response.data.status;
      } else {
        openNotificationWithIcon("error", "ErrosGerais");
      }
    } catch (err) {
      console.log(err);
    }
  } else {
    document.location.href = "/login";
  }
}

export function qualSituacao(
  alugar: number,
  trocar: number,
  concluido: number,
  utilizar: number,
  tipo: number,
  situacao: string
) {
  //tipo 1 buscar situação pelos parametros alugar, trocar, utilizar e concluido
  //tipo 2 pelo nome de exibição, transformando para o tipo descrito no backEnd
  if (tipo === 1) {
    if (alugar === 1 && trocar === 1) {
      return "ALUGAR_TROCAR";
    } else {
      if (alugar === 1 && trocar === 0) {
        return "ALUGAR";
      } else {
        if (concluido === 1) {
          return "CONCLUIDO_PELO_PROPRIO";
        } else {
          if (utilizar === 1) {
            return "UTILIZADO";
          } else {
            console.log("Tem algo errado com os períodos");
          }
        }
      }
    }
  } else {
    if (tipo === 2) {
      if (situacao === "Alugar ou trocar") {
        return "ALUGAR_TROCAR";
      } else {
        if (situacao === "Alugar") {
          return "ALUGAR";
        } else {
          if (situacao === "Reservado pelo próprio") {
            return "CONCLUIDO_PELO_PROPRIO";
          } else {
            if (situacao === "Será utilizado") {
              return "UTILIZADO";
            } else {
              console.log("Tem algo errado com os períodos");
            }
          }
        }
      }
    }
  }
}

export function tratamentoValoresInput(props: any) {
  let valor = parseInt(props);
  if (isNaN(valor)) {
    return false;
  } else {
    return valor;
  }
}

export async function atualizarPeriodoUsuario(props: any) {
  const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${
    props.periodoUsuarioId ? props.periodoUsuarioId : props.periodoUsuario
  }`;
  const Token = validateToken();

  if (Token) {
    switch (props.caso) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
      case 8:
      case 9:
        const { caso, ...formData } = props;

        try {
          const responseAlterando = await axios.put(URL, formData, {
            headers: { Authorization: Token.AuthStr },
          });
          if (responseAlterando) {
            return 1;
          } else {
            console.log("deu algo errado");
          }
        } catch (err) {
          if (err.response.status === 500) {
            alert("Há algo de errado. Por favor, entre em contato conosco1.");
          }

          return 2;
        }
        break;
    }
  } else {
    console.log("sem token");
  }
}

export async function criarOuDeletarPeriodoUsuario(props: any, tipo: string) {
  //tipos: CRIAR - DELETAR
  const URLCriar = `${Globais.DOMINIOBACK}/periodo-usuario/`;
  const URLDeletar = `${Globais.DOMINIOBACK}/periodo-usuario/${props.id}`;
  const Token = validateToken();

  if (tipo === "CRIAR") {
    if (Token) {
      try {
        const responseCriando = await axios.post(URLCriar, props, {
          headers: { Authorization: Token.AuthStr },
        });
        if (responseCriando) {
          return 1;
        } else {
          console.log("deu algo errado");
          return 2;
        }
      } catch (err) {
        if (err.response.status === 500) {
          alert("Há algo de errado. Por favor, entre em contato conosco2.");
        }

        return 2;
      }
    } else {
      document.location.href = "/login";
    }
  } else {
    if (tipo === "DELETAR") {
      if (Token) {
        try {
          const responseDeletando = await axios.delete(URLDeletar, {
            headers: { Authorization: Token.AuthStr },
          });
          if (responseDeletando) {
            return 1;
          } else {
            console.log("deu algo errado");
            return 2;
          }
        } catch (err) {
          if (err.response.status === 500) {
            console.log(
              "Há algo de errado. Por favor, entre em contato conosco3."
            );
          }

          return 2;
        }
      } else {
        document.location.href = "/login";
      }
    } else {
      if (tipo === "DELETAR_DIVULGADO") {
        const { tipo, ...result } = props;
        if (Token) {
          try {
            const responseAtualizando = await axios.put(URLDeletar, result, {
              headers: { Authorization: Token.AuthStr },
            });
            if (responseAtualizando) {
              return 1;
            } else {
              console.log("deu algo errado");
              return 2;
            }
          } catch (err) {
            if (err.response.status === 500) {
              alert("Há algo de errado. Por favor, entre em contato conosco4.");
            }

            return 2;
          }
        } else {
          document.location.href = "/login";
        }
      }
    }
  }
}

export async function verificarSeTemPeriodoDivulgado(periodoUsuarioId: number) {
  const Token = validateToken();
  if (Token) {
    let URLPrincipal = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuarioId}`;
    let URLPEUFrac = "";

    try {
      const responsePrincipal = await axios.get(URLPrincipal, {
        headers: { Authorization: Token.AuthStr },
      });
      if (responsePrincipal) {
        if (responsePrincipal.data.divulgado === 1) {
          return true;
        } else {
          if (responsePrincipal.data.fracionamento === 0) {
            URLPEUFrac = `${Globais.DOMINIOBACK}/periodo-usuario/fracionados/${periodoUsuarioId}`;
          } else {
            URLPrincipal = `${Globais.DOMINIOBACK}/periodo-usuario/${responsePrincipal.data.fracionamento}`;

            try {
              const responsePrincipal2 = await axios.get(URLPrincipal, {
                headers: { Authorization: Token.AuthStr },
              });
              if (responsePrincipal2) {
                if (responsePrincipal2.data.divulgado === 1) {
                  return true;
                } else {
                  URLPEUFrac = `${Globais.DOMINIOBACK}/periodo-usuario/fracionados/${responsePrincipal.data.fracionamento}`;
                }
              }
            } catch (e) {
              console.log(e);
            }
          }
          try {
            const responseFrac = await axios.get(URLPEUFrac, {
              headers: { Authorization: Token.AuthStr },
            });

            if (responseFrac.data.length > 0) {
              let contador = 0;

              responseFrac.data.map((p: any) => {
                if (p.divulgado === 1) {
                  contador++;
                } else {
                  return null;
                }
              });

              if (contador !== 0) {
                return true;
              } else {
                return false;
              }
            }
          } catch (e) {
            console.log(e);
          }
        }
      }
    } catch (err) {
      openNotificationWithIcon("error", "ErrosGerais");
    }
  } else {
    document.location.href = "/login";
  }
}

export async function deletarPeriodoUsuario(
  periodoUsuarioId: number,
  deletaPeriodo: boolean
) {
  const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuarioId}`;
  const Token = validateToken();
  if (Token) {
    try {
      const responseDeletando = await axios.delete(URL, {
        headers: { Authorization: Token.AuthStr },
      });

      if (responseDeletando) {
        if (deletaPeriodo) {
          const URLPeriodo = `${Globais.DOMINIOBACK}/periodo/${responseDeletando.data.periodoId}`;
          try {
            const responseDeletandoPeriodo = await axios.delete(URLPeriodo, {
              headers: { Authorization: Token.AuthStr },
            });
            if (responseDeletandoPeriodo) {
              return 1;
            }
          } catch (error) {
            console.log("deu algo errado");
          }
        } else {
          return 1;
        }
      } else {
        console.log("deu algo errado");
      }
    } catch (err) {
      if (err.response.status == 500) {
        alert("Há algo de errado. Por favor, entre em contato conosco5.");
      }

      return 2;
    }
  } else {
    console.log("sem token");
  }
}

//função que devolve fase atual do período do usuário. Usado para sugestões de valores, para evitar que uma sugetsão seja enviadas várias vezes a um propritário que já aceitou ou recusou a sugestão.
// as fases definem também a distancia do período em relação ao checkin e consequentemente o percentual de desconto, se houver,  de acordo com a estratégia de preço.

export async function definirFasePeriodoUsuario(props: any) {
  let confirmando = props.confirmando;
  let nCheckIn;
  let diferenca;
  let novaFase;
  if (props.checkIn) {
    nCheckIn = props.checkIn;
  } else {
    if (props.periodoId) {
      nCheckIn = "24/02/2024";
    }
  }

  let hoje = exibirDataFuncaoDate(new Date());

  if (confirmando) {
    diferenca = CalcularDiferencaDias(
      AlterarFormatoData(nCheckIn),
      AlterarFormatoData(hoje)
    );
  } else {
    diferenca = CalcularDiferencaDias(
      AlterarFormatoData(formatarData(nCheckIn)),
      AlterarFormatoData(hoje)
    );
  }

  if (diferenca < 60) {
    novaFase = "FASE5";
  } else {
    if (diferenca < 90) {
      novaFase = "FASE4";
    } else {
      if (diferenca < 120) {
        novaFase = "FASE3";
      } else {
        if (diferenca < 150) {
          novaFase = "FASE2";
        } else {
          if (diferenca < 180) {
            novaFase = "FASE1";
          } else {
            if (diferenca >= 180) {
              novaFase = "FASE0";
            } else {
              console.log("não foi possível definir a fase");
            }
          }
        }
      }
    }
  }

  return novaFase;
}
